import React from 'react'
import style from './WhoWeAre.module.css'
const data = [
    {
        image: '/NewPages/Homepage/Collabrate.svg',
        title: 'Collborate Easily',
        description: 'Real-time editing and feedback for LaTeX manuscripts.',
        backgroundcolor: ' #FFF0EA',
    },
    {
        image: '/NewPages/Homepage/EfficientEditing.svg',
        title: 'Efficient Editing',
        description: 'Ensure accuracy and consistency with a user-friendly interface.',
        backgroundcolor: ' #F4EAFF',
    },
    {
        image: '/NewPages/Homepage/Enhanced.svg',
        title: 'Enhanced Presentation',
        description: 'Streamline academic and technical document typesetting.',
        backgroundcolor: '#E9F8FF',
    }
]

const WhoWeAre = () => {
    return (
        <div className='container'>
            <div className={style.whoweareContainer}>
                <div className={style.textcontainer} >
                    <p className={style.whowearetitle}>{'{ Who We Are }'}</p>
                    <div className={style.information}>

                        <h1> Online Collaboration, Write, Edit & Format research paper in Latex</h1>
                        <div className={style.description}>

                            <p>Transforma offers publishers innovative LaTeX-based solutions, enhancing content precision and enabling faster information sharing for authors and researchers.</p>
                        </div>
                    </div>
                </div>
                <Card />
            </div>

        </div>
    )
}

export default WhoWeAre


export const Card = () => {
    return <>
        <div id="about" className='container'>
            <div className={style.CardsContainer}>
                {data.map((item, index) => (<>
                    <div key={index} className={style.cardContainer} style={{ background: item.backgroundcolor }}>
                        <img src={process.env.PUBLIC_URL + item.image} alt="" />
                        <p className={style.cardheading} >{item.title}</p>
                        <p className={style.whocardDescription} style={{ color: "#484848", textAlign: "center" }}>{item.description}</p>
                    </div>
                </>))}
            </div>
        </div>
    </>
}